import React from "react"
import PropTypes from "prop-types"
import { useHits } from 'react-instantsearch';
import classNames from "classnames"
import Hit from "./hit"

const findMatch = (colours, thumbs) => {
	const matches = colours.filter(match => thumbs.includes(match))
	return matches[0]
}

const renderImage = (hit, colour) => {

	if (hit.thumbnails && Object.keys(hit.thumbnails).length) {
		if (!colour) {
			return hit.thumbnails[Object.keys(hit.thumbnails)[0]];
		}

		return hit.thumbnails[findMatch(colour, Object.keys(hit.thumbnails))];

	}
	return <div className="thumbnail__placeholder" />
}
function HitsList(){
      const { items } = useHits();
    return (
        <div className="product-list">
        {items.slice(0, 4).map(hit => (
            <Hit
                key={hit.objectID}
                title={hit.title}
                image={Object.keys(hit.thumbnails).length
                    ? renderImage(hit, null)
                    : null}
                absoluteUri={hit.absoluteUri}
            />))}
    </div>
    )
}
    

 function RelatedProducts({ query, isActive }){

    return (<div className={classNames("search__results", { "is-active": isActive })}>
        <div className="container">
            <div className="typeahead-results__section">
                <HitsList query={query} />
            </div>
        </div>
    </div>)
 }
RelatedProducts.propTypes = {
      hits: PropTypes.arrayOf(PropTypes.object),
};  
export default RelatedProducts